import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { snakes } from '@utils/lodash';
import { API_V1_BASE } from '@config';
import { WithParams } from '@utils/typescript';

export type CheckAuthOtpCodeParams = WithParams<{
  mobile_number: string;
}>;

export type VerifyAuthOtpCodeParams = WithParams<{
  mobile_number: string;
  otp_code: string;
}>;

export class AuthOtpCodeApi {
  static check = async (params: CheckAuthOtpCodeParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/auth/otp_code/check`, snakes(params));
  };

  static verify = async (params: VerifyAuthOtpCodeParams) => {
    return await authAxios
      .post(`${API_V1_BASE}/auth/otp_code/verify`, snakes(params))
      .then((response) => humps(response.data) as { accessToken: string });
  };
}
